import { toast } from "react-toastify";
import { axiosConfig } from "./config";
class commonServiceInstance {
  async request(method, url, data = null) {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type":
          method === "post" || method === "put"
            ? "application/x-www-form-urlencoded; charset=UTF-8"
            : "application/json",
      };

      const response = await axiosConfig({
        method,
        url,
        data,
        headers,
      });

      return response.data;
    } catch (err) {
      if (err?.response) {
        toast.error(err.response.data?.message);
      } else {
        toast.error("Network Error or unexpected issue:", err?.message);
      }
      throw err; 
    }
  }

  // HTTP GET
  get(url) {
    return this.request("get", url);
  }

  // HTTP DELETE
  async delete(url) {
    try {
      const response = await axiosConfig({
        method: "delete",
        url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (err) {
      if (err?.response) {
        toast.error(err.response.data?.message);
      } else {
        toast.error("Network Error or unexpected issue:", err?.message);
      }
      throw err;
    }
  }
  // HTTP POST
  post(url, data) {
    return this.request("post", url, data);
  }

  // HTTP PUT
  put(url, data) {
    return this.request("put", url, data);
  }
}

const CommonService = new commonServiceInstance();

export default CommonService;
